<template>
    <div class="relative bg-gray-100">
        <Intercom />
        <Navbar @handleSideBarMobile="() => {}" />

        <!--        <CyberMondayBanner-->
        <!--            v-if="shouldDisplayBlackFridayDeal"-->
        <!--            class="sticky z-20 top-14 md:relative md:top-0"-->
        <!--        />-->

        <BannerStack />

        <div
            v-if="globalProps.user.isImpersonating"
            class="fixed bottom-0 left-0 flex flex-wrap items-center justify-between w-full px-10 py-2 z-500 bg-gray-900/50"
        >
            <div class="my-1 text-sm text-white">
                You are now seeing the app as: {{ globalProps.user.name }}
            </div>
            <AtomicButton size="sm" color="purple" @click="endImpersonation">
                <template #icon>
                    <EyeSlashIcon class="w-6 h-6 mr-2" />
                </template>
                Leave impersonation
            </AtomicButton>
        </div>

        <div
            class="grid min-h-[calc(100vh-56px)] grid-cols-1 md:min-h-[calc(100vh-64px)] md:grid-cols-[64px_1fr] xl:grid-cols-[256px_1fr]"
        >
            <PluginSidebar
                v-if="globalProps.user.app_type === 'plugin' && !isKiosk"
                v-click-away="onClickAway"
                :opened="sidebarOpened"
                @close="sidebarOpened = false"
                @open="sidebarOpened = true"
            />
            <Sidebar
                v-else-if="globalProps.user.app_type === 'pro' || globalProps.user.app_type === 'both' || globalProps.user.app_type === null || isKiosk"
                v-click-away="onClickAway"
                :opened="sidebarOpened"
                @close="sidebarOpened = false"
                @open="sidebarOpened = true"
            />

            <div
                class="mx-auto w-full px-5 pt-[56px] opacity-100 blur-none transition duration-300 ease-in-out sm:px-10 md:pt-0 xl:max-w-[1328px] xl:opacity-100 xl:blur-none"
                :class="{
                    'pointer-events-none md:opacity-90 md:blur-xs':
                        sidebarOpened,
                }"
            >
                <slot />
            </div>
        </div>

        <ConfirmDialog></ConfirmDialog>
        <Notifications></Notifications>

        <ShoppingCartModal />
    </div>
</template>
<script lang="ts" setup>
import Navbar from '@components/Navigation/Navbar.vue';
import Sidebar from '@components/Navigation/Sidebar.vue';
import PluginSidebar from '@components/Navigation/PluginSidebar.vue';
import { computed, onMounted, ref } from 'vue';
import ConfirmDialog from '@atomic/Dialogs/ConfirmDialog.vue';
import Notifications from '@/components/Notifications.vue';
import { usePage } from '@inertiajs/vue3';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import BannerStack from '../components/Navigation/components/BannerStack.vue';
import AtomicButton from '@/components/Atomic/Buttons/AtomicButton.vue';
import { router } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { EyeSlashIcon } from '@heroicons/vue/24/outline';
import Bugsnag from '@bugsnag/js';
import ICurrentTeam from '@/types/Members/ICurrentTeam';

const globalProps = computed(() => usePage<ITopolPageProps>().props);
const teamProps = computed(() => globalProps.value.team as ICurrentTeam);

onMounted(async () => {
    const userObject = {
        id: globalProps.value.user.id,
        email: globalProps.value.user.email,
        current_team_id: teamProps.value.id,
    };
    Bugsnag.setUser(JSON.stringify(userObject));

    await getData();
});

const { fetchBanners } = useBanners();

const { fetchSubscriptions } = useSubscriptions();

const { fetchTeams, getCurrentTeamMembersCount } = useTeamsAndMembers();

const page = computed(() => usePage<ITopolPageProps>().url);
const isKiosk = computed(() => {
    return page.value.startsWith('/kiosk');
});

const getData = async () => {
    await fetchSubscriptions();
    await fetchBanners();
    await getCurrentTeamMembersCount();
    await fetchTeams();
};

const sidebarOpened = ref(false);
const onClickAway = () => {
    sidebarOpened.value = false;
};
const endImpersonation = () => {
    router.delete(
        route('kiosk.users.nonimpersonate', {
            user: globalProps.value.user.id,
        }),
        {
            onSuccess: () => {
                getData();
            },
        }
    );
};
</script>

<style></style>
